




















































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { MedTransGoConstants } from '../util/constants';
import '../assets/css/Settings.scss';
import '../assets/css/DataTable.scss';
import MessageBox from '../components/MessageBox.vue';
import { validationMixin } from 'vuelidate';
import { ObjectFactory } from '../config/objectFactory';
import { CommonUtils } from '../util/commonUtils';
import { ApiResponse, DispatcherProfile, DriverProfile, InterpreterProfile, Vehicle } from '@/types/response';
import { ApiRequest, QueryRecordsRequest, SignupRequest, UpdatePartnerProfileRequest } from '@/types/request';
import { InterpreterLanguage, TransporterLoc } from '@/types/entity';
import DataTable from '../components/DataTable.vue';
import AddLocationModal from './modal/AddLocationModal.vue';
import UpdateLocationModal from './modal/UpdateLocationModal.vue';
import AddDriverModal from './modal/AddDriverModal.vue';
import UpdateDriverModal from './modal/UpdateDriverModal.vue';
import ViewDocumentModal from './modal/ViewDocumentModal.vue';
import UplodDriversModal from './modal/UploadDriversModal.vue';
import UpdateDocumentModal from './modal/UpdateDocumentModal.vue';
import UpdateQuestionnaireModal from './modal/UpdateQuestionnaireModal.vue';
import AddLanguageModal from './modal/AddLanguageModal.vue';
import { ToastEvent } from '../types/event';
import { EventBus } from '../main';
import UpdateUserProfileModal from './modal/UpdateUserProfileModal.vue';
import { DateUtils } from '@/util/dateUtils';
import AddVehicleModal from './modal/AddVehicleModal.vue';
import ViewVehicleDetailModal from './modal/ViewVehicleDetailModal.vue';
import UpdateVehicleModal from './modal/UpdateVehicleModal.vue';
import UploadVehiclesModal from './modal/UploadVehiclesModal.vue';
import { required, minLength, email } from 'vuelidate/lib/validators';
import UploadDriverDocumentsModal from './UploadDriverDocumentsModal.vue';
import AddTransporterDriverDetailsModal from './modal/AddTransporterDriverDetailsModal.vue';
// tslint:disable-next-line: no-var-requires
const AchTable = require('../datatable/AchTable.json');
// tslint:disable-next-line: no-var-requires
const LocationTable = require('../datatable/LocationTable.json');
// tslint:disable-next-line: no-var-requires
const DriverTable = require('../datatable/DriverTable.json');
// tslint:disable-next-line: no-var-requires
const VehicleTable = require('../datatable/VehicleTable.json');
// tslint:disable-next-line: no-var-requires
const TransporterDocumentTable = require('../datatable/DocumentsTable');
// tslint:disable-next-line: no-var-requires
const LanguagesTable = require('../datatable/LanguagesTable');
// tslint:disable-next-line: no-var-requires
const QuestionnariesDataTable = require('../datatable/QuestionnariesDataTable');
// tslint:disable-next-line: no-var-requires
const DispatcherTable = require('../datatable/DispatcherTable');
// tslint:disable-next-line: no-var-requires
const partnerDocuments = require('../config/ProfileFormData');
// tslint:disable-next-line: no-var-requires
const subInterpretersDataTable = require('../datatable/SubInterpreterTable');
// tslint:disable-next-line: no-var-requires
const TransporterDriverDocumentsTable = require('../datatable/TransporterDriverDocumentsTable');
// tslint:disable-next-line: no-var-requires
const PartnerDocumentsDataSource = require('../datatable/DocumentsTable');
@Component({
    mixins: [validationMixin],
    data() {
        return {
            fullName: '',
            phone: '',
            email: '',
            companyName: '',
            address: {
                fullAddress: '',
                locality: '',
                state: '',
                city: '',
                zip: '',
            },
            licenceNo: '',
            licenceState: '',
            expireYear: '',
            timezone: '',
            language: '',
            interpreterRating: '',
            transporterRating: '',
            showAddSubInterpreterModal: false,
            childInterpreter: {
                fullName: '',
                email: '',
                phone: '',
                id: '',
            },
            isDriverEnabled: false,
        };
    },
    validations: {
        childInterpreter: {
            fullName: {
                required,
                regex: (fullName: any) => /^[a-zA-Z ]+$/.test(fullName),
            },
            email: {
                required,
                email,
            },
            phone: {
                required,
                minLength: minLength(10),
                regex: (phone: any) => MedTransGoConstants.PHONE_REGX.test(phone),
            },
        },
    },
    components: {
        MessageBox,
        DataTable,
        AddLocationModal,
        UpdateLocationModal,
        AddDriverModal,
        UpdateDriverModal,
        ViewDocumentModal,
        UpdateUserProfileModal,
        UplodDriversModal,
        UpdateDocumentModal,
        AddLanguageModal,
        UpdateQuestionnaireModal,
        AddVehicleModal,
        ViewVehicleDetailModal,
        UpdateVehicleModal,
        UploadVehiclesModal,
        UploadDriverDocumentsModal,
        AddTransporterDriverDetailsModal,
    },
    watch: {
        $route(to, from) {
            if (!to.path.endsWith(MedTransGoConstants.URL_ADD_DRIVER)
                || !to.path.endsWith(MedTransGoConstants.URL_UPDATE_PROFILE)
                || !to.path.endsWith(MedTransGoConstants.URL_ADD_USER)) {
                const settings = this as Setting;
                settings.getTranspoterLocation();
                settings.getDrivers('', 0);
                settings.getPartnerProfile();
                settings.getDispatchers('', 0);
            }
        },
    },
})
export default class Setting extends Vue {
    private locationsDataSource = LocationTable;
    private driversDataSource = DriverTable;
    private vehicleDataSource = VehicleTable;
    private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
    private showLocationModal = false;
    private resourceId: any;
    private vehicleId: any;
    private showDocumentModal = false;
    private questionnaireDataTable = QuestionnariesDataTable;
    private partnerRequiredDocuments = partnerDocuments;
    private dispatchersDataSource = DispatcherTable;
    private transporterDocumentDataSource = TransporterDocumentTable;
    private driverDocumentDataSource = TransporterDocumentTable;
    private languageDataSource = LanguagesTable;
    private transporterId: any;
    private showUplodDriversModal = false;
    private showAddVehicle = false;
    private showViewVehicle = false;
    private documentName: any;
    private showUpdateDocumentModal = false;
    private showUpdateVehicleModal = false;
    private showUploadVehicleModal = false;
    private uploadNemtac = false;
    private driverStart = 0;
    private vehicleStart = 0;
    private showLanguage = false;
    private showUpdateQuestionnaireModal = false;
    private selectedQuestion = null;
    private subInterpreterDataSource = subInterpretersDataTable;
    private errors: any = [];
    private partnerUserId = '';
    private isChildInterpreter = false;
    private editInterpreter = false;
    private interpretersStart = 0;
    private transporterDriverDocument = TransporterDriverDocumentsTable;
    private showUploadDocument = false;
    private driverProfile: DriverProfile = { address: {} } as any;
    private documents: Document[] = [];
    private transporterDriverDetailsForm = false;
    private transporterAsDriverId: any;
    private partnerDocumentsDataSource = PartnerDocumentsDataSource;

    public async mounted() {
        await this.getPartnerProfile();
        await this.getDrivers('', 0);
        this.getDriverProfile();
    }

    private checkDocumentRequired(document: any, roles: string[]) {
        let isDocumentRequired = false;
        if (roles && roles.length >= 0) {
            roles.forEach((element) => {
                if (document.requiredFor && document.requiredFor.includes(element)) {
                    isDocumentRequired = true;
                }
            });
        }
        return isDocumentRequired;
    }

    private async getPartnerProfile() {
        const partnerService = ObjectFactory.getPartnerService();
        const response = await partnerService.getPartnerProfile(this.$store.state.serverUrl);
        if (response.success && response.data) {
            if (this.sessionInfo.scopes.includes('dispatcher')) {
                if (response.data.dispatcherProfile) {
                    this.transporterId = response.data.dispatcherProfile.transporterId;
                }
            }
            const partnerProfile = response.data;
            if (partnerProfile.interpreterProfile) {
                this.$data.fullName = partnerProfile.interpreterProfile.address;
                this.$data.fullName = partnerProfile.interpreterProfile.fullname;
                this.$data.email = partnerProfile.interpreterProfile.email;
                this.$data.phone = partnerProfile.interpreterProfile.phone;
                this.$data.address = partnerProfile.interpreterProfile.address;
                this.$data.language = partnerProfile.interpreterProfile.languages[0];
                this.$data.timezone = partnerProfile.interpreterProfile.timezone;
                this.languageDataSource.data = partnerProfile.interpreterProfile.languages;
                this.$data.interpreterRating = partnerProfile.interpreterProfile.rating;
                partnerProfile.interpreterProfile.languages.forEach((element) => {
                    element.certificates.forEach((certificate) => {
                        if (certificate && certificate.expirationTime) {
                            if (certificate.expirationTime <= DateUtils.getCurrentTimeInMillis()) {
                            certificate.status = 'EXPIRED';
                            }
                        }
                        certificate.expirationTime = certificate.expirationTime ? DateUtils.
                            formatDate(certificate.expirationTime, 'MM/DD/YYYY') : '-' as any;
                        certificate.auditedOn = certificate.auditedOn ? DateUtils.formatDate(certificate.auditedOn, 'MM/DD/YYYY') : '-' as any;
                    });
                });
                if (partnerProfile.interpreterProfile.parentInterpreterId) {
                    this.isChildInterpreter = true;
                } else {
                    this.getInterpreterList('', 0);
                }
            }
            if (partnerProfile.transporterProfile) {
                if (partnerProfile.transporterProfile.isDriver) {
                    this.$data.isDriverEnabled = true;
                }
                this.getTranspoterLocation();
                this.getDrivers();
                this.getVehicles();
                this.getDispatchers();
                this.$data.address = partnerProfile.transporterProfile.address;
                this.$data.fullName = partnerProfile.transporterProfile.fullname;
                this.$data.email = partnerProfile.transporterProfile.email;
                this.$data.phone = partnerProfile.transporterProfile.phone;
                this.$data.companyName = partnerProfile.transporterProfile.companyName;
                this.$data.timezone = partnerProfile.transporterProfile.timezone;
                this.$data.transporterRating = partnerProfile.transporterProfile.rating;
                this.transporterId = partnerProfile.transporterProfile.id;
                if (partnerProfile.transporterProfile.questionnaires) {
                    partnerProfile.transporterProfile.questionnaires.forEach((element) => {
                        if (typeof element.answer === 'boolean' ||
                            element.answer === 'true' || element.answer === 'false') {
                            element.answer = ((typeof element.answer === 'boolean' &&
                                (element.answer)) || element.answer === 'true') ? 'Yes' : 'No';
                        }
                    });
                    this.buildQuestionnaire(partnerProfile);
                }
                const objIndex = partnerProfile.transporterProfile.documents.findIndex(((obj) =>
                    obj.name === 'NEMTAC'));
                if (objIndex >= 0) {
                    const document = partnerProfile.transporterProfile.documents[objIndex];
                    if (document.verified) {
                        this.uploadNemtac = false;
                    } else {
                        this.uploadNemtac = true;
                    }
                } else {
                    this.uploadNemtac = true;
                }
                if (partnerProfile.transporterProfile && partnerProfile.transporterProfile.roles) {
                    const roles = partnerProfile.transporterProfile.roles;
                    this.partnerRequiredDocuments.documents.forEach((document: any) => {
                        const isRequiredDocument = this.checkDocumentRequired(document, roles);
                        if (isRequiredDocument) {
                            if (!document.resourceId || !document.filename) {
                                this.transporterDocumentDataSource.data.push(document);
                            }
                        }
                    });

                }
                if (partnerProfile.transporterProfile.documents) {
                    this.buildDocumentReponse(partnerProfile);
                }
            }
            if (partnerProfile.homeHealthCareProfile) {
                this.$data.address = partnerProfile.homeHealthCareProfile.address;
                this.$data.fullName = partnerProfile.homeHealthCareProfile.fullname;
                this.$data.email = partnerProfile.homeHealthCareProfile.email;
                this.$data.phone = partnerProfile.homeHealthCareProfile.phone;
                this.$data.companyName = partnerProfile.homeHealthCareProfile.companyName;
                this.$data.timezone = partnerProfile.homeHealthCareProfile.timezone;
                if (partnerProfile.homeHealthCareProfile.questionnaires) {
                    partnerProfile.homeHealthCareProfile.questionnaires.forEach((element) => {
                        if (typeof element.answer === 'boolean' ||
                            element.answer === 'true' || element.answer === 'false') {
                            element.answer = ((typeof element.answer === 'boolean' &&
                                (element.answer)) || element.answer === 'true') ? 'Yes' : 'No';
                        }
                    });
                    this.buildQuestionnaire(partnerProfile);
                }
                if (partnerProfile.homeHealthCareProfile.documents) {
                    this.buildDocumentReponse(partnerProfile);
                }
            }
            if (partnerProfile.driverProfile) {
                this.$data.address = partnerProfile.driverProfile.address;
                this.$data.fullName = partnerProfile.driverProfile.fullname;
                this.$data.email = partnerProfile.driverProfile.email;
                this.$data.phone = partnerProfile.driverProfile.phone;
                this.$data.licenceNo = partnerProfile.driverProfile.licenceNo;
                this.$data.licenceState = partnerProfile.driverProfile.licenceState;
                this.$data.expireYear = DateUtils.formatDate(partnerProfile.driverProfile.expireYear, 'MM/DD/YYYY');
                this.driverDocumentDataSource.data = partnerProfile.driverProfile.documents;
                if (partnerProfile.driverProfile.documents !== undefined) {
                    partnerProfile.driverProfile.documents.forEach((element) => {
                        if (element.verified) {
                            element.status = 'Verified';
                        } else if (element.rejected) {
                            element.status = 'Rejected';
                        } else {
                            element.status = 'Not Verified';
                            // tslint:disable-next-line:align
                        } if (element.expirationDate && element.expirationDate <= DateUtils.getCurrentTimeInMillis()) {
                            element.status = 'Expired';
                            // tslint:disable-next-line:align
                        } element.expirationDate = element.expirationDate ?
                            DateUtils.formatDate(element.expirationDate, 'MM/DD/YYYY') : '-' as any;
                    });
                    if (this.partnerRequiredDocuments.driverDocuments.length !== undefined) {
                        this.partnerRequiredDocuments.driverDocuments.forEach((document: any) => {
                            if (partnerProfile && partnerProfile.driverProfile &&
                                    partnerProfile.driverProfile.documents) {
                                const documentIndex = partnerProfile.driverProfile.documents.findIndex
                                    ((uploadedDocument: any) => {
                                        return (uploadedDocument.name === document.name);
                                    });
                                if (documentIndex === -1) {
                                    this.driverDocumentDataSource.data.push(document);
                                }
                            }
                        });
                    }
                }
            }

            if (partnerProfile.dispatcherProfile) {
                this.$data.address = partnerProfile.dispatcherProfile.address;
                this.$data.fullName = partnerProfile.dispatcherProfile.fullname;
                this.$data.email = partnerProfile.dispatcherProfile.email;
                this.$data.phone = partnerProfile.dispatcherProfile.phone;
                this.$data.timezone = partnerProfile.dispatcherProfile.timezone;
                this.transporterId = partnerProfile.dispatcherProfile.transporterId;
                this.$data.companyName = partnerProfile.dispatcherProfile.companyName;
            }
        }
    }

    private async buildDocumentReponse(partnerProfile: any) {
        if (this.sessionInfo.scopes.includes('transporter')) {
            partnerProfile.transporterProfile.documents.forEach((element: any) => {
                if (element.verified) {
                    element.status = 'Verified';
                } else if (element.rejected) {
                    element.status = 'Rejected';
                } else {
                    element.status = 'Not Verified';
                }
                if (element.expirationDate && element.expirationDate <= DateUtils.getCurrentTimeInMillis()) {
                    element.status = 'Expired';
                }
                element.expirationDate = element.expirationDate ?
                    DateUtils.formatDate(element.expirationDate, 'MM/DD/YYYY') : '-' as any;
            });
            this.partnerDocumentsDataSource.data = partnerProfile.transporterProfile.documents;
            this.partnerDocumentsDataSource.perPage = this.partnerDocumentsDataSource.data.length;
        }
        if (this.sessionInfo.scopes.includes('homeHealthCare')) {
            partnerProfile.homeHealthCareProfile.documents.forEach((element: any) => {
                if (element.verified) {
                    element.status = 'Verified';
                } else if (element.rejected) {
                    element.status = 'Rejected';
                } else {
                    element.status = 'Not Verified';
                }
                if (element.expirationDate && element.expirationDate <= DateUtils.getCurrentTimeInMillis()) {
                    element.status = 'Expired';
                }
                element.expirationDate = element.expirationDate ?
                    DateUtils.formatDate(element.expirationDate, 'MM/DD/YYYY') : '-' as any;
            });
            this.partnerDocumentsDataSource.data = partnerProfile.homeHealthCareProfile.documents;
            this.partnerDocumentsDataSource.perPage = this.partnerDocumentsDataSource.data.length;
        }
        if (this.sessionInfo.scopes.includes('homeHealthCare') && this.sessionInfo.scopes.includes('transporter')) {
            partnerProfile.homeHealthCareProfile.documents.forEach((element: any) => {
                if (element.verified) {
                    element.status = 'Verified';
                } else if (element.rejected) {
                    element.status = 'Rejected';
                } else {
                    element.status = 'Not Verified';
                }
                if (element.expirationDate && element.expirationDate <= DateUtils.getCurrentTimeInMillis()) {
                    element.status = 'Expired';
                }
                element.expirationDate = element.expirationDate ?
                    DateUtils.formatDate(element.expirationDate, 'MM/DD/YYYY') : '-' as any;
            });
            partnerProfile.transporterProfile.documents.forEach((element: any) => {
                if (element.verified) {
                    element.status = 'Verified';
                } else if (element.rejected) {
                    element.status = 'Rejected';
                } else {
                    element.status = 'Not Verified';
                }
                if (element.expirationDate && element.expirationDate <= DateUtils.getCurrentTimeInMillis()) {
                    element.status = 'Expired';
                }
                element.expirationDate = element.expirationDate ?
                    DateUtils.formatDate(element.expirationDate, 'MM/DD/YYYY') : '-' as any;
            });
            const combinedDocuments = [
                ...partnerProfile.transporterProfile.documents,
                ...partnerProfile.homeHealthCareProfile.documents,
            ];
            const uniqueDocuments = Array.from(
                new Map(combinedDocuments.map((doc) => [doc.description, doc])).values());
            this.partnerDocumentsDataSource.data = uniqueDocuments;
            this.partnerDocumentsDataSource.perPage = this.partnerDocumentsDataSource.data.length;
        }
    }

    private async buildQuestionnaire(partnerProfile: any) {
        if (this.sessionInfo.scopes.includes('transporter') && !this.sessionInfo.scopes.includes('homeHealthCare')) {
            this.questionnaireDataTable.data = partnerProfile.transporterProfile.questionnaires;
        }
        if (this.sessionInfo.scopes.includes('homeHealthCare') && !this.sessionInfo.scopes.includes('transporter')) {
            this.questionnaireDataTable.data = partnerProfile.homeHealthCareProfile.questionnaires;
        }
        if (this.sessionInfo.scopes.includes('transporter')
            && this.sessionInfo.scopes.includes('homeHealthCare')) {
            const transporterQuestionnaire = partnerProfile.transporterProfile.questionnaires;
            const homeHealthCareQuestionnaire = partnerProfile.homeHealthCareProfile.questionnaires;
            this.questionnaireDataTable.data = [
                ...(transporterQuestionnaire as any [] || []),
                ...(homeHealthCareQuestionnaire as any [] || []),
            ];
        }
        this.questionnaireDataTable.data.forEach((element: any) => {
            if (typeof element.question === 'string' && element.question.includes('??')) {
                element.question = element.question.replace(/\?\?/g, '?');
            }
        });
        this.questionnaireDataTable.perPage = this.questionnaireDataTable.data.length;
    }

    private uploadNemtacDocument() {
        this.documentName = 'NEMTAC';
        this.showUpdateDocumentModal = true;
    }

    private async viewCertificate(language: InterpreterLanguage) {
        if (language.certificates) {
            language.certificates.forEach((element) => {
                this.viewDocument({ resourceId: element.certificateId });
            });
        }
    }
    private showUpdateQuestionnaireForm(question: any) {
        this.selectedQuestion = question;
        this.showUpdateQuestionnaireModal = true;
    }
    private showAddLanguageModal() {
        this.showLanguage = true;
    }

    private logout() {
        CommonUtils.logout(this.$store.state);
    }

    private goBack() {
        this.$router.push({ name: MedTransGoConstants.VIEW_REQUESTS_PANEL_NAME });
    }

    private async getTranspoterLocation(searchString?: string, start?: number) {
        if (!start) {
            start = 0;
        }
        if (this.sessionInfo.scopes.includes('transporter') || this.sessionInfo.scopes.includes('dispatcher')) {
            const iHttpService = ObjectFactory.getHttpService();
            const queryRecordsRequest: QueryRecordsRequest = {
                limit: MedTransGoConstants.PAGINATION_LIMIT,
                start,
            };
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                data: queryRecordsRequest,
                url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/location/list`,
                loaderEvent: {
                    show: true,
                },
            };
            const response = await iHttpService.get<TransporterLoc[]>(apiRequest);
            if (response.data && response.success) {
                if (start !== undefined) {
                    this.locationsDataSource.data = response.data.slice(start, start + 10);
                }
                if (response.data.length !== undefined) {
                    this.locationsDataSource.totalCount = response.data.length;
                }
            } else {
                CommonUtils.showError(response);
            }
        }
    }

    private showAddLocationForm() {
        this.showLocationModal = true;
    }

    private showUpdateLocationForm(locations: any) {
        this.$router.push({ append: true, path: `${MedTransGoConstants.URL_UPDATE_LOCATION}/${locations.id}` });
    }
    private updateProfile() {
        const id = this.sessionInfo.id;
        if (this.sessionInfo.scopes.includes('driver')) {
            this.$router.push({ append: true, path: `${MedTransGoConstants.URL_UPDATE_DRIVER}/${id}` });
        } else {
            this.$router.push({ append: true, path: `${MedTransGoConstants.URL_UPDATE_PROFILE}/${id}` });
        }
    }
    private async getDrivers(searchString?: string, start?: number) {
        if (typeof start !== 'undefined') {
            this.driverStart = start;
        } else if (this.driverStart > 0) {
            start = this.driverStart;
        }
        if (this.sessionInfo.scopes.includes('transporter') || this.sessionInfo.scopes.includes('dispatcher')) {
            const iHttpService = ObjectFactory.getHttpService();
            const queryRecordsRequest: QueryRecordsRequest = {
                start,
                limit: MedTransGoConstants.PAGINATION_LIMIT,
                order: {
                    status: -1,
                },
            };
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                data: queryRecordsRequest,
                url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/driver/list`,
                loaderEvent: {
                    show: true,
                },
            };
            const response = await iHttpService.post<DriverProfile[]>(apiRequest);
            if (response.data && response.success) {
                response.data.forEach((element) => {
                    if (element.status === 'PENDING_VERIFICATION') {
                        element.status = 'Under Review' as any;
                    } else if (element.status === 'ACTIVE') {
                        element.status = 'Active' as any;
                    } else if (element.status === 'DEACTIVATED') {
                        element.status = 'Deactive' as any;
                    } else if (element.status === 'DEACTIVE') {
                        element.status = 'Deactive' as any;
                    }
                });
                this.driversDataSource.data = response.data;
                if (response.totalCount !== undefined) {
                    this.driversDataSource.totalCount = response.totalCount;
                }
            } else {
                CommonUtils.showError(response);
            }
        }
    }

    private async getVehicles(searchString?: string, start?: number) {
        if (typeof start !== 'undefined') {
            this.vehicleStart = start;
        } else if (this.vehicleStart > 0) {
            start = this.vehicleStart;
        }
        if (this.sessionInfo.scopes.includes('transporter')) {
            const iHttpService = ObjectFactory.getHttpService();
            const queryRecordsRequest: QueryRecordsRequest = {
                start: start ? start : 0,
                limit: MedTransGoConstants.PAGINATION_LIMIT,
                order: {
                    status: -1,
                },
                conditions: [{
                    op: 'ne',
                    fieldName: 'status',
                    value: 'DELETED',
                }],
            };
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                data: queryRecordsRequest,
                url: `${MedTransGoConstants.HTTP_URL_VEHICLE}/list`,
                loaderEvent: {
                    show: true,
                },
            };
            const response = await iHttpService.post<Vehicle[]>(apiRequest);
            if (response.data && response.success) {
                response.data.forEach((vehicle) => {
                    vehicle.equippedForWheelchair = vehicle.equippedForWheelchair ? 'Yes' : 'No' as any;
                    vehicle.equippedForStretcher = vehicle.equippedForStretcher ? 'Yes' : 'No' as any;
                });
                this.vehicleDataSource.data = response.data;
                if (response.totalCount !== undefined) {
                    this.vehicleDataSource.totalCount = response.totalCount;
                }
            } else {
                CommonUtils.showError(response);
            }
        }
    }


    private async deleteVehicle(vehicle: Vehicle) {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_VEHICLE}/delete/${vehicle.id}`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.delete<string>(apiRequest);
        if (response.success) {
            this.getVehicles();
            const toastEvent: ToastEvent = {
                message: `Vehicle deleted successfully`,
                title: 'Message',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        } else {
            CommonUtils.showError(response);
        }
    }

    private showUploadVehicleForm() {
        this.showUploadVehicleModal = true;
    }

    private viewDocument(document?: any) {
        this.resourceId = document.resourceId;
        this.showDocumentModal = true;
    }

    private showAddDriverForm() {
        this.$router.push({ name: MedTransGoConstants.VIEW_ADD_DRIVER_NAME });
    }

    private showAddVehicleForm() {
        this.showAddVehicle = true;
    }

    private showViewVehicleForm(vehicle: Vehicle) {
        this.vehicleId = vehicle.id;
        this.showViewVehicle = true;

    }

    private showUpdateVehicleForm(vehicle: Vehicle) {
        this.vehicleId = vehicle.id;
        this.showUpdateVehicleModal = true;
    }

    private showUploadDriverForm() {
        this.showUplodDriversModal = true;
    }
    private viewDriver(driver: any) {
        this.$router.push({ append: true, path: `${MedTransGoConstants.URL_VIEW_DRIVER}/${driver.id}` });

    }

    private showUpdateDriverForm(driver: any) {
        this.$router.push({ append: true, path: `${MedTransGoConstants.URL_UPDATE_DRIVER}/${driver.id}` });
    }

    private uploadDocuments(document: any) {
        const id = this.sessionInfo.id;
        this.$router.push({
            append: true,
            path: `${MedTransGoConstants.URL_UPLOAD_DOCUMENT}/${id}`, query: { doc: document.name },
        });
    }

    private async deactivateDriver(driver: DriverProfile) {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/driver/deactivate/${driver.id}`,
            loaderEvent: {
                show: true,
            },
        };
        iHttpService.delete<string>(apiRequest).then((response: ApiResponse<string>) => {
            if (response.success) {
                this.getDrivers();
                const toastEvent: ToastEvent = {
                    message: 'Driver record has been deactivated',
                    title: 'Success',
                    varient: 'success',
                    timeout: 5000,
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            } else {
                CommonUtils.showError(response);
            }
        });
    }

    private uploadDriverDocuments( ) {
        this.showUploadDocument = true;
    }

    private async deleteDriver(driver: DriverProfile) {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/driver/${driver.id}`,
            loaderEvent: {
                show: true,
            },
        };
        iHttpService.delete<string>(apiRequest).then((response: ApiResponse<string>) => {
            if (response.success) {
                this.getDrivers();
                const toastEvent: ToastEvent = {
                    message: 'Driver record has been deleted',
                    title: 'Success',
                    varient: 'success',
                    timeout: 5000,
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            } else {
                CommonUtils.showError(response);
            }
        });
    }

    private async activateDriver(driver: DriverProfile) {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/driver/reactivate/${driver.id}`,
            loaderEvent: {
                show: true,
            },
        };
        iHttpService.put<string>(apiRequest).then((response: ApiResponse<string>) => {
            if (response.success) {
                this.getDrivers();
                const toastEvent: ToastEvent = {
                    message: 'Driver record has been activated',
                    title: 'Success',
                    varient: 'success',
                    timeout: 5000,
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            } else {
                CommonUtils.showError(response);
            }
        });
    }

    private async deleteLanguage(language: InterpreterLanguage) {
        const iHttpService = ObjectFactory.getHttpService();
        const userId = ObjectFactory.getCacheService().getSessionInfo().id;
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_INTERPRETERS}/${userId}/languages/${language.languageId}`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.delete<string>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: `Language deleted successfully`,
                title: 'Message',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        } else {
            CommonUtils.showError(response);
        }
    }

    private showAddUserForm() {
        this.$router.push({ name: MedTransGoConstants.VIEW_ADD_UESR_NAME });
    }

    private async deleteDispatcher(dispatcher: DispatcherProfile) {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/dispatcher/${dispatcher.id}`,
            loaderEvent: {
                show: true,
            },
        };
        iHttpService.delete<string>(apiRequest).then((response: ApiResponse<string>) => {
            if (response.success) {
                this.getDispatchers();
                const toastEvent: ToastEvent = {
                    message: 'Dispatcher record has been deleted',
                    title: 'Success',
                    varient: 'success',
                    timeout: 5000,
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            } else {
                CommonUtils.showError(response);
            }
        });
    }

    private async changeUserToDriver(dispatcher: DispatcherProfile) {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/changeToDriver/${dispatcher.id}`,
            loaderEvent: {
                show: true,
            },
        };
        iHttpService.put<any>(apiRequest).then((response: ApiResponse<any>) => {
            if (response.success) {
                this.getDrivers();
                this.getDispatchers();
                const toastEvent: ToastEvent = {
                    message: 'User has been changed to driver successfully',
                    title: 'Success',
                    varient: 'success',
                    timeout: 5000,
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            } else {
                CommonUtils.showError(response);
            }
        });
    }

    private async changeDriverToUser(driver: DriverProfile) {
        if (this.sessionInfo.scopes.includes('transporter')) {
            const iHttpService = ObjectFactory.getHttpService();
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/changeToUser/${driver.id}`,
                loaderEvent: {
                    show: true,
                },
            };
            iHttpService.put<any>(apiRequest).then((response: ApiResponse<any>) => {
                if (response.success) {
                    this.getDrivers();
                    this.getDispatchers();
                    const toastEvent: ToastEvent = {
                        message: 'Driver has been changed to User successfully',
                        title: 'Success',
                        varient: 'success',
                        timeout: 5000,
                    };
                    EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                } else {
                    CommonUtils.showError(response);
                }
            });
        } else {
            const toastEvent: ToastEvent = {
                message: `Permission Denied`,
                title: 'Message',
                varient: 'danger',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        }
    }

    private async deactivateDispatcher(dispatcher: DispatcherProfile) {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/dispatcher/deactivate/${dispatcher.id}`,
            loaderEvent: {
                show: true,
            },
        };
        iHttpService.delete<string>(apiRequest).then((response: ApiResponse<string>) => {
            if (response.success) {
                this.getDispatchers('', 0);
                const toastEvent: ToastEvent = {
                    message: 'Dispatcher record has been deactivated',
                    title: 'Success',
                    varient: 'success',
                    timeout: 5000,
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            } else {
                CommonUtils.showError(response);
            }
        });
    }

    private async activeteDispatcher(dispatcher: DispatcherProfile) {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/dispatcher/reactivate/${dispatcher.id}`,
            loaderEvent: {
                show: true,
            },
        };
        iHttpService.put<string>(apiRequest).then((response: ApiResponse<any>) => {
            if (response.success) {
                this.getDispatchers('', 0);
                const toastEvent: ToastEvent = {
                    message: 'Dispatcher record has been Activated',
                    title: 'Success',
                    varient: 'success',
                    timeout: 5000,
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            } else {
                CommonUtils.showError(response);
            }
        });
    }

    private async getDispatchers(searchString?: string, start?: number) {
        if (typeof start !== 'undefined') {
            this.driverStart = start;
        } else if (this.driverStart > 0) {
            start = this.driverStart;
        }
        if (this.sessionInfo.scopes.includes('transporter')) {
            const iHttpService = ObjectFactory.getHttpService();
            const queryRecordsRequest: QueryRecordsRequest = {
                start,
                limit: MedTransGoConstants.PAGINATION_LIMIT,
                order: {
                    status: -1,
                },
            };
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                data: queryRecordsRequest,
                url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/dispatcher/list`,
                loaderEvent: {
                    show: true,
                },
            };
            const response = await iHttpService.post<DispatcherProfile[]>(apiRequest);
            if (response.data && response.success) {
                response.data.forEach((element) => {
                    if (element.status === 'PENDING_VERIFICATION') {
                        element.status = 'Under Review' as any;
                    } else if (element.status === 'ACTIVE') {
                        element.status = 'Active' as any;
                    } else if (element.status === 'DEACTIVATED') {
                        element.status = 'Deactive' as any;
                    } else if (element.status === 'DEACTIVE') {
                        element.status = 'Deactive' as any;
                    }
                });
                this.dispatchersDataSource.data = response.data;
                if (response.totalCount !== undefined) {
                    this.dispatchersDataSource.totalCount = response.totalCount;
                }
            } else {
                CommonUtils.showError(response);
            }
        }
    }

    private showAddInterpreterModal(show: boolean) {
        this.$data.showAddSubInterpreterModal = show;
        if (!show) {
            this.editInterpreter = false;
            this.$data.childInterpreter = {
                fullName: '',
                email: '',
                phone: '',
            };
        }
    }

    private maskPhone(phone: string) {
        return CommonUtils.phoneNumberMask(phone);
    }

    private async getInterpreterList(searchString?: string, start?: number):
        Promise<ApiResponse<InterpreterProfile[]>> {
        if (typeof start !== 'undefined') {
            this.interpretersStart = start;
        } else if (this.interpretersStart > 0) {
            start = this.interpretersStart;
        }
        const iHttpService = ObjectFactory.getHttpService();
        const queryRecordsRequest: QueryRecordsRequest = {
            conditions: [{
                op: 'eq',
                fieldName: 'parentInterpreterId',
                value: this.sessionInfo.id,
            }],
            start,
            limit: MedTransGoConstants.PAGINATION_LIMIT,
            order: {
                status: -1,
            },
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            data: queryRecordsRequest,
            url: `${MedTransGoConstants.HTTP_URL_INTERPRETERS}/list`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<InterpreterProfile[]>(apiRequest);
        if (response.success && response.data) {
            this.subInterpreterDataSource.data = response.data;
            if (response.totalCount !== undefined) {
                this.subInterpreterDataSource.totalCount = response.totalCount;
            }
        } else {
            CommonUtils.showError(response);
        }
        return response;
    }
    private async addSubInterpreter() {
        this.errors = [];
        const iHttpService = ObjectFactory.getHttpService();
        const signupRequest: SignupRequest = {
            clientId: this.$store.state.clientId,
            fullName: this.$data.childInterpreter.fullName,
            email: this.$data.childInterpreter.email,
            phone: this.$data.childInterpreter.phone,
            password: CommonUtils.generatePassword(8),
            scopes: ['interpreter'],
            parentInterpreterId: this.sessionInfo.id,
        };
        const request: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_PARTNERS}/signup`,
            data: signupRequest,
            loaderEvent: {
                show: true,
                message: 'Signing up',
            },
        };
        const response = await iHttpService.post<any>(request);
        if (response.success && response.data) {
            const toastEvent: ToastEvent = {
                message: 'Interpreter has been Added Successfully',
                title: 'Success',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        } else {
            CommonUtils.showError(response);
        }
        this.showAddInterpreterModal(false);
        this.getInterpreterList('', 0);
    }

    private showEditInterpreterModal(interpreter: any) {
        this.$data.childInterpreter.fullName = interpreter.fullname;
        this.$data.childInterpreter.email = interpreter.email;
        this.$data.childInterpreter.phone = interpreter.phone;
        this.$data.childInterpreter.id = interpreter.id;
        this.editInterpreter = true;
        this.showAddInterpreterModal(true);
    }

    private async updateInterpreterProfile() {
        const partnerService = ObjectFactory.getPartnerService();
        const userId = this.$data.childInterpreter.id;
        const updateProfileResponse = await partnerService.updateUserProfile({
            email: this.$data.childInterpreter.email,
            fullname: this.$data.childInterpreter.fullName,
            phone: this.$data.childInterpreter.phone,
        }, this.$store.state.serverUrl, userId);
        if (updateProfileResponse.success) {
            const updatePartnerProfileRequest: UpdatePartnerProfileRequest = {};
            const updatePartnerProfileResponse = await partnerService
                .updatePartnerProfile(updatePartnerProfileRequest, this.$store.state.serverUrl);
            if (updatePartnerProfileResponse.success && updatePartnerProfileResponse.data) {
                const toastEvent: ToastEvent = {
                    message: 'Interpreter has been Updated Successfully',
                    title: 'Success',
                    varient: 'success',
                    timeout: 5000,
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            } else {
                CommonUtils.showError(updatePartnerProfileResponse);
            }
        }
        this.showAddInterpreterModal(false);
        this.getInterpreterList('', 0);
    }

    private async getDriverProfile() {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/driver/${this.transporterId}`,
        };
        const response = await iHttpService.get<DriverProfile>(apiRequest);
        this.transporterDriverDocument.data = [];
        if (response.success && response.data) {
            this.driverProfile = response.data;
            if (response.data.documents && response.data.documents.length > 0) {
                response.data.documents.forEach(async (element) => {
                    element.status = element.rejected ? 'Rejected' : element.verified ? 'Verified' : 'Not Verified';
                    element.expirationDate = element.expirationDate ? DateUtils.formatDate(element.expirationDate, 'MM/DD/YYYY') : '-' as any;
                    element.verifiedOn = element.verifiedOn ? DateUtils.formatDate(element.verifiedOn) : '-' as any;
                    let user: any;
                    if (element.verifiedBy) {
                        user = await ObjectFactory.getRequestService().getUserById(element.verifiedBy,
                            this.$store.state.serverUrl);
                    }
                    element.verifiedBy = element.verifiedBy ? user.fullname : '-';
                });
                this.transporterDriverDocument.data = response.data.documents;
            } else {
                this.transporterDriverDocument.data = [];
            }
        } else {
            CommonUtils.showError(response);
        }
    }

    private async togglePermission() {
        this.$data.isDriverEnabled = ! this.$data.isDriverEnabled;
        if (this.$data.isDriverEnabled) {
            this.transporterDriverDetailsForm = true;
        }
        if (!this.$data.isDriverEnabled) {
            await this.revokeTransporterAsDriver();
        }
    }

    private async revokeTransporterAsDriver() {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/TransporterAsdriver/revoke`,
                loaderEvent: {
                    show: true,
                },
            };
        const response = await iHttpService.post<any>(apiRequest);
        if (response.success && response.data) {
            const toastEvent: ToastEvent = {
                message: 'Driver Removed Successfully',
                title: 'Success',
                timeout: 5000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        } else {
            CommonUtils.showError(response);
        }
        this.getPartnerProfile();
    }
}
